var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NebulaBlockMessage',{staticClass:"message-empty-state",attrs:{"icon":"calendar-add","header":"New Connect Scheduled!","description":_vm.emptyMessage}})
}
var staticRenderFns = []

export { render, staticRenderFns }